// Create a new file: /components/workflow/CustomAgentNode.jsx
import React from 'react';
import { Handle, Position } from 'reactflow';
import { Wand2 } from 'lucide-react'; // A different icon for "custom"
import { BsBraces } from "react-icons/bs"; // NEW: Import icon for JSON output indicator

const CustomAgentNode = ({ id, data }) => {
    const statusStyles = {
        idle: "border-cyan-700",
        pending: "border-yellow-400",
        queued: "border-blue-400",
        failed: "border-red-500",
        success: "border-green-500",
        running: "animate-[pulse_1s_infinite] border-green-500",
        approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
        diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
    };

    // Default to 'idle' if status is not provided or invalid
    const status = data?.status || "idle";
    const isLoading = status === "running" || status === "pending" || status === "diagnosing";

    const hasJsonOutput = data?.jsonOutput === true;

    const outputFieldCount = Object.keys(data.jsonOutputSchema?.properties || {}).length;

    return (
        <div className={`w-72 bg-zinc-800 border-2 rounded-lg shadow-lg ${statusStyles[status]}`}>
            <div className="p-3 border-b border-zinc-700 bg-zinc-900/50 rounded-t-lg flex items-center gap-3 justify-between">
                <div className="flex items-center gap-2">
                    <Wand2 className="text-cyan-400" size={20} />
                    <h3 className="font-bold text-base text-white">Custom Agent</h3> {id}
                </div>
                <div className="flex items-center gap-2">
                    {hasJsonOutput && (
                        <div title="Structured JSON Output Enabled" className="cursor-help">
                            <BsBraces className="h-4 w-4 text-cyan-400" />
                        </div>
                    )}
                    {isLoading && (
                        <div className="animate-spin h-4 w-4 border-2 border-zinc-500 border-t-white rounded-full" />
                    )}
                </div>
            </div>
            <div className="p-3 text-xs text-slate-300 space-y-1">
                <p>
                    <span className="font-semibold text-slate-400">Label:</span> {data.label || 'Custom AI Agent'}
                </p>
                <p>
                    <span className="font-semibold text-slate-400">Output Fields:</span> {outputFieldCount}
                </p>
            </div>
            <Handle type="source" position={Position.Right} className="w-3 h-3 !bg-teal-500" />
            <Handle type="target" position={Position.Left} className="w-3 h-3 !bg-rose-500" />
        </div>
    );
};

export default CustomAgentNode;